import ForgotPasswordForm from '../../components/forgotPassword/ForgotPasswordForm';

const ForgotPassword = () => {
  return (
    <>
      <ForgotPasswordForm />
    </>
  );
};

export default ForgotPassword;
